import { WSAlert } from "@wingspanhq/fe-component-library";
import { useAllPayerListQuery } from "../../../query/payers/queries/useAllPayerListQuery";
import { TaxYear } from "../../../shared/constants/taxYear";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import { PATH_ONBOARDING_VERIFICAIONS_TAX } from "../../Onboarding";
import { useHistory } from "react-router-dom";
import { useTaxVerificationVersion } from "../../../shared/hooks/useTaxVerificationVersion";
import { ConfirmTaxInformationForLegacyUserAlert } from "./ConfirmTaxInformationForLegacyUserAlert";

export const ConfirmTaxInformationForLegacyUserAlertWithClients: React.FC<{
  currentYear: TaxYear;
  showWithNoPayer?: boolean;
}> = ({ currentYear, showWithNoPayer = false }) => {
  const history = useHistory();
  const { isLegacyOnlyTaxVerification, isLoading } =
    useTaxVerificationVersion();

  const queryAllPayers = useAllPayerListQuery(
    {},
    {
      enabled: isLegacyOnlyTaxVerification
    }
  );

  const payer = queryAllPayers.data?.find(payer => {
    return payer.payerSettings?.taxFilingSettings[`${currentYear}`]
      ?.filing1099Enabled;
  });

  if (!queryAllPayers.isFetched || isLoading || !isLegacyOnlyTaxVerification) {
    return null;
  }

  if (payer) {
    const payerName = wsName({
      member: payer.member,
      user: payer.user!
    }).getResolvedName();

    return (
      <WSAlert
        title="Confirm your tax information"
        theme="warning"
        icon="alert"
        action={{
          text: "Confirm tax information",
          onClick: () => {
            history.push(PATH_ONBOARDING_VERIFICAIONS_TAX);
          }
        }}
      >
        {payerName} is preparing to file your 1099 tax form and needs you to
        re-verify your W-9 information. The verification system has been
        upgraded and this is a one-time confirmation to ensure your information
        is accurate and complete.
      </WSAlert>
    );
  } else if (showWithNoPayer && !payer) {
    return <ConfirmTaxInformationForLegacyUserAlert />;
  }

  return null;
};
